module.exports = __webpack_public_path__ + "static/img/coe-heavy-horse-grey.698f582.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/coe-heavy-horse-grey.svg
// module id = exoO
// module chunks = 74